export default function Footer() {
  const links = [
    { label: "概要", href: "#overview" },
    { label: "機能", href: "#features" },
    { label: "コマンド", href: "#commands" },
    { label: "導入方法", href: "#integration" },
    { label: "サポート", href: "#support" },
  ];

  return (
    <footer className="bg-gray-50 border-t border-gray-100 py-16 px-6">
      <div className="max-w-6xl mx-auto">
        <div className="flex flex-col md:flex-row items-start justify-between gap-10 mb-12">
          {/* Brand */}
          <div className="flex items-center gap-2.5">
            <img
              src="https://storage.readdy-site.link/project_files/caeb4770-bff8-4a6c-aacf-b2169351eb6e/f9f885c4-cf1a-4153-aa6b-79a8a47d3db7_unnamed.png?v=32f9e45271c38a3f927699f78a81a4f1"
              alt="時間割くん"
              className="w-8 h-8 rounded-lg object-cover"
            />
            <span className="font-semibold text-black text-sm">時間割くん</span>
          </div>

          {/* Nav links */}
          <div className="flex flex-wrap gap-x-8 gap-y-3">
            {links.map((l) => (
              <a
                key={l.label}
                href={l.href}
                className="text-gray-500 hover:text-black text-sm transition-colors cursor-pointer"
              >
                {l.label}
              </a>
            ))}
          </div>
        </div>

        <div className="border-t border-gray-200 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-gray-400 text-xs">
            &copy; {new Date().getFullYear()} 時間割くん. All rights reserved.
          </p>
          <p className="text-gray-400 text-xs">
            Made by kurekure_botti
          </p>
        </div>
      </div>
    </footer>
  );
}
